import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import SEO, { SEO_CONFIG } from '@/components/SEO';
import { 
  Sparkles,
  Apple,
  Sun,
  Activity,
  Users
} from 'lucide-react';

export const InstructorsPage = () => {
  const navigate = useNavigate();

  // Coming Soon - Eğitmenler henüz hazır değil
  return (
    <div className="min-h-screen pt-20 bg-gradient-to-b from-purple-50 via-white to-purple-50" data-testid="instructors-page">
      <SEO {...SEO_CONFIG.instructors} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Coming Soon Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full mb-6">
            <Users className="h-12 w-12 text-purple-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Uzman Eğitmenlerimiz Çok Yakında
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-2">
            Sertifikalı eğitmenlerimiz ders içeriklerini hazırlıyor.
          </p>
          <p className="text-gray-500 max-w-2xl mx-auto">
            Bu süreçte AI destekli koçluk ve beslenme özelliklerimizi kullanabilirsiniz.
          </p>
        </div>

        {/* Active Features Grid */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">
            ✨ Şimdi Aktif Özellikler
          </h2>
          <div className="grid md:grid-cols-2 gap-4">
            {/* AI Koç */}
            <Card 
              className="cursor-pointer hover:shadow-lg transition-all hover:-translate-y-1 border-indigo-200 bg-gradient-to-br from-indigo-50 to-purple-50"
              onClick={() => navigate('/ai-coach')}
            >
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-indigo-100 rounded-xl">
                    <Sparkles className="h-6 w-6 text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-gray-900">AI Koç</h3>
                    <p className="text-gray-600 text-sm">Kişisel motivasyon ve hedef takibi</p>
                    <Badge className="mt-2 bg-green-100 text-green-700">Aktif ✓</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* AI Diyetisyen */}
            <Card 
              className="cursor-pointer hover:shadow-lg transition-all hover:-translate-y-1 border-green-200 bg-gradient-to-br from-green-50 to-emerald-50"
              onClick={() => navigate('/ai-dietitian')}
            >
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-green-100 rounded-xl">
                    <Apple className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-gray-900">AI Diyetisyen</h3>
                    <p className="text-gray-600 text-sm">Kişiselleştirilmiş beslenme önerileri</p>
                    <Badge className="mt-2 bg-green-100 text-green-700">Aktif ✓</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Günlük Check-in */}
            <Card 
              className="cursor-pointer hover:shadow-lg transition-all hover:-translate-y-1 border-orange-200 bg-gradient-to-br from-orange-50 to-yellow-50"
              onClick={() => navigate('/daily-checkin')}
            >
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-orange-100 rounded-xl">
                    <Sun className="h-6 w-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-gray-900">Günlük Check-in</h3>
                    <p className="text-gray-600 text-sm">Ruh halinizi takip edin, öneriler alın</p>
                    <Badge className="mt-2 bg-green-100 text-green-700">Aktif ✓</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Aktivite Takibi */}
            <Card 
              className="cursor-pointer hover:shadow-lg transition-all hover:-translate-y-1 border-blue-200 bg-gradient-to-br from-blue-50 to-cyan-50"
              onClick={() => navigate('/activity')}
            >
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-blue-100 rounded-xl">
                    <Activity className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-gray-900">Aktivite Takibi</h3>
                    <p className="text-gray-600 text-sm">Adım, yürüyüş ve egzersiz kayıtları</p>
                    <Badge className="mt-2 bg-green-100 text-green-700">Aktif ✓</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Become Instructor CTA */}
        <div className="text-center bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-8">
          <h3 className="font-semibold text-xl text-gray-900 mb-2">
            🎓 Eğitmen Olmak İster Misiniz?
          </h3>
          <p className="text-gray-600 mb-4">
            Pilatika'da kendi derslerinizi oluşturun ve öğrencilere ulaşın.
          </p>
          <Button 
            className="btn-primary"
            onClick={() => navigate('/become-instructor')}
          >
            <Users className="h-4 w-4 mr-2" />
            Eğitmen Başvurusu Yap
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InstructorsPage;
